import { IconBox, SourceIcon } from "@hightouch/htui";
import type { SchemaIconProps } from "./types";

export const CatalogIcon = ({ size = "xl", ...props }: SchemaIconProps) => {
  return <IconBox color="blue" icon={<SourceIcon />} size={size} {...props} />;
};
